import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStock } from '../../context/StockContext';
import { useStockAuth } from '../../context/StockAuthContext';
import toast from 'react-hot-toast';

const B = '#0B3D6E', T = '#0F6E56';

export default function StockUpgrade() {
  const { upgradePlan } = useStock();
  const { user } = useStockAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      await upgradePlan();
      toast.success('🎉 Plan Pro activé ! Accès illimité débloqué.');
      navigate('/stock/dashboard');
    } catch(err) {
      toast.error('Erreur lors de la mise à niveau');
    } finally { setLoading(false); }
  };

  const features = {
    free: ['20 produits maximum','Alertes stock de base','Suivi des mouvements','Dashboard standard'],
    pro:  ['Produits illimités','Alertes avancées + email','Historique complet','Export PDF / Excel','Analyses et rapports','Support prioritaire','Multi-utilisateurs (bientôt)'],
  };

  return (
    <div style={{ maxWidth:700, margin:'0 auto', padding:'2rem 1rem' }}>
      <div style={{ textAlign:'center', marginBottom:'2rem' }}>
        <div style={{ fontSize:40, marginBottom:10 }}>⭐</div>
        <h1 style={{ fontSize:24, fontWeight:600, marginBottom:8 }}>Passez au Plan Pro</h1>
        <p style={{ fontSize:14, color:'#64748b', lineHeight:1.7 }}>Débloquez toutes les fonctionnalités pour gérer votre stock sans limites</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:'2rem' }}>
        {/* Free */}
        <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:16, padding:'1.5rem', opacity: user?.plan==='pro'?0.5:1 }}>
          <div style={{ fontSize:13, fontWeight:500, color:'#64748b', marginBottom:6 }}>Plan Gratuit</div>
          <div style={{ fontSize:28, fontWeight:700, color:'#1a2535', marginBottom:'1rem' }}>0 MAD<span style={{ fontSize:14, fontWeight:400, color:'#94a3b8' }}>/mois</span></div>
          {features.free.map(f=>(
            <div key={f} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8, fontSize:13, color:'#475569' }}>
              <span style={{ color:T, flexShrink:0 }}>✓</span>{f}
            </div>
          ))}
          {user?.plan==='free' && <div style={{ marginTop:'1rem', background:'#E6F1FB', color:B, fontSize:12, fontWeight:600, padding:'8px', borderRadius:8, textAlign:'center' }}>Plan actuel</div>}
        </div>

        {/* Pro */}
        <div style={{ background:`linear-gradient(135deg,${B},${T})`, border:'none', borderRadius:16, padding:'1.5rem', color:'#fff', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:-20, right:-20, width:100, height:100, background:'rgba(255,255,255,0.06)', borderRadius:'50%' }}/>
          <div style={{ fontSize:13, fontWeight:500, color:'rgba(255,255,255,0.75)', marginBottom:6 }}>Plan Pro</div>
          <div style={{ fontSize:28, fontWeight:700, marginBottom:4 }}>299 MAD<span style={{ fontSize:14, fontWeight:400, opacity:0.75 }}>/mois</span></div>
          <div style={{ fontSize:11, opacity:0.7, marginBottom:'1rem' }}>ou 2 490 MAD/an (économisez 30%)</div>
          {features.pro.map(f=>(
            <div key={f} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8, fontSize:13 }}>
              <span style={{ color:'#5DCAA5', flexShrink:0 }}>✓</span>{f}
            </div>
          ))}
          {user?.plan==='pro' ? (
            <div style={{ marginTop:'1rem', background:'rgba(255,255,255,0.2)', fontSize:12, fontWeight:600, padding:'8px', borderRadius:8, textAlign:'center' }}>Plan actuel ✓</div>
          ) : (
            <button onClick={handleUpgrade} disabled={loading} style={{ width:'100%', marginTop:'1rem', background:'#fff', color:B, border:'none', padding:'11px', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', opacity:loading?0.7:1 }}>
              {loading?'Activation...':'Activer le Plan Pro →'}
            </button>
          )}
        </div>
      </div>

      <div style={{ background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, padding:'1rem 1.2rem', fontSize:13, color:'#64748b', textAlign:'center' }}>
        💳 Paiement sécurisé — Annulable à tout moment — Satisfaction garantie 30 jours
      </div>
    </div>
  );
}

